import { Link } from '@reach/router';
import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../../common/static.styles';
import { HeadTitle } from '../../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../../layout/default/DefaultLayout';

const StyledServices = styled(StyledInformationalPage)`
  .contact-line {
    margin-top: 6em;
  }
`;

/* tslint:disable:max-line-length */
const seo = {
  description:
    "Warner Bros. Studios offers many services to the community. From finding a job to renting a stage on the historic Warner Bros. lot and more, here's everything you need to know about: Clip Still Licensing. For entities interested in licensing use of Warner Bros. photographic and video properties. Production Services. Warner Bros. Studio Operations.",
};
/* tslint:enable:max-line-length */

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='en-US' seo={seo}>
    <HeadTitle title='Studio Services' />
    <StyledServices>
      <div className='content'>
        <h1>WB Services</h1>
        <div>
          <p>
            Warner Bros. Studios offers many services to the community. From finding a job to renting a stage on the
            historic Warner Bros. lot and more, here's everything you need to know about:
          </p>
          <p>
            <strong>
              <Link to='/studio/services/clip-and-still-licensing'>Clip &amp; Still Licensing</Link>&nbsp;-&nbsp;
            </strong>
            For entities interested in licensing use of Warner Bros.' photographic and video properties
          </p>
          <p>
            <strong>
              <a href={'http://studiofacilities.warnerbros.com/'} target='_blank'>
                Production Services
              </a>
              &nbsp;-&nbsp;
            </strong>
            Warner Bros. Studio Operations
          </p>
          <p>
            <strong>
              <a href={'http://www.wbspecialevents.com/'} target='_blank'>
                Special Events
              </a>
              &nbsp;-&nbsp;
            </strong>
            Learn how to rent out the Warner Bros. studio for you or your company's private events
          </p>
          <p>
            <strong>
              <a href={'https://www.warnerbroscareers.com/'} target='_blank'>
                Warner Bros. Careers
              </a>
              &nbsp;-&nbsp;
            </strong>
            If you are interested in working at Warner Bros, this is the place to look
          </p>
          <p>
            <strong>
              <a href={'http://www.wbstudiotour.com/'} target='_blank'>
                Warner Bros. Studio Tour Hollywood
              </a>
              &nbsp;-&nbsp;
            </strong>
            Arrange a trip to the historic Warner Bros. lot
          </p>
        </div>
      </div>
    </StyledServices>
  </DefaultLayout>
);
